export class ListItemBuilder {
    constructor() {
        this.build = () => {
            return {
                '@type': 'ListItem',
                position: this.position || 0,
                item: {
                    '@type': 'Thing',
                    '@id': this.id || '',
                    name: this.name || '',
                },
            };
        };
    }
    withPosition(position) {
        this.position = position;
        return this;
    }
    withName(name) {
        this.name = name;
        return this;
    }
    withId(id) {
        this.id = id;
        return this;
    }
}
ListItemBuilder.aBuilder = () => {
    return new ListItemBuilder();
};
export class BreadcrumbBuilder {
    constructor() {
        this.listItems = [];
        this.withListItem = (listItem) => {
            this.listItems && this.listItems.push(listItem);
            return this;
        };
        this.build = () => {
            return {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: this.listItems || [],
            };
        };
    }
}
BreadcrumbBuilder.aBuilder = () => {
    return new BreadcrumbBuilder();
};
